/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AtoNDefinitionAlarmSetupInner
 */
export interface AtoNDefinitionAlarmSetupInner {
    /**
     * 
     * @type {string}
     * @memberof AtoNDefinitionAlarmSetupInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AtoNDefinitionAlarmSetupInner
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AtoNDefinitionAlarmSetupInner
     */
    sms?: string;
    /**
     * 
     * @type {string}
     * @memberof AtoNDefinitionAlarmSetupInner
     */
    url?: string;
}

/**
 * Check if a given object implements the AtoNDefinitionAlarmSetupInner interface.
 */
export function instanceOfAtoNDefinitionAlarmSetupInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AtoNDefinitionAlarmSetupInnerFromJSON(json: any): AtoNDefinitionAlarmSetupInner {
    return AtoNDefinitionAlarmSetupInnerFromJSONTyped(json, false);
}

export function AtoNDefinitionAlarmSetupInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtoNDefinitionAlarmSetupInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'sms': !exists(json, 'sms') ? undefined : json['sms'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function AtoNDefinitionAlarmSetupInnerToJSON(value?: AtoNDefinitionAlarmSetupInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'sms': value.sms,
        'url': value.url,
    };
}

